import React, { Fragment, useState } from 'react'
import { map, uniqBy, sortBy } from 'lodash'

import ClusterReport from "./ClusterReport";
import HostReport from "./HostReport";
import VMReport from "./VMReport";
import VcenterReport from "./VcenterReport";

const Tab = ({ name, openTab, setOpenTab }) => (
  <li className="nav-item">
    <a className={`nav-link ${openTab === name && 'active'}`} onClick={_ => setOpenTab(name)}>
      {name}
    </a>
  </li>
)
const sitesFromData = (data) => sortBy(uniqBy(map(data, 'site'), 'name'), 'name')

const clustersTable = ({ clusters }) => <ClusterReport {...{ clusters, sites: sitesFromData(clusters) }} />
const hostsTable = ({ hosts }) => <HostReport {...{ hosts, sites: sitesFromData(hosts) }} />
const vmsTable = ({ vms }) => <VMReport {...{ vms, sites: sitesFromData(vms) }} />
const vcentersTable = ({ vcenters }) => <VcenterReport {...{ vcenters }} />

const VcenterAssetReport = ({ data = {} }) => {
  const tabNames = ['vCenters', 'Clusters', 'Hosts', 'VMs']
  const [openTab, setOpenTab] = useState(tabNames[0])
  const ReportComponents = {
    Clusters: { call: _ => clustersTable(data) },
    Hosts: { call: _ => hostsTable(data) },
    VMs: { call: _ => vmsTable(data) },
    vCenters: { call: _ => vcentersTable(data) },
  }

  return (
    <Fragment>
      <ul className="nav nav-tabs">
        {_.map(tabNames, name => <Tab key={name} {...{ name, openTab, setOpenTab }} />)}
      </ul>

      {ReportComponents[openTab].call()}
    </Fragment>
  )
}

export default VcenterAssetReport
